<template>
  <div class="menu-mobile menu-activated-on-click color-scheme-dark">
    <div class="mm-logo-buttons-w">
      <!--  <a class="mm-logo"
         href=""><img src="@/assets/img/logo-white.svg"><span class="logo-label">TURASISTAN</span></a> -->
      <div class="mm-buttons">
        <div class="content-panel-open">
          <div class="os-icon os-icon-grid-circles"/>
        </div>
        <div class="mobile-menu-trigger">
          <div class="os-icon os-icon-hamburger-menu-1"/>
        </div>
      </div>
    </div>
    <div class="menu-and-user">
      <li class="logo-icone">
        <a class="mm-logo"
           href=""><img :src="displayAppImage"><span class="logo-label">{{ displayAppName }}</span></a>
      </li>
      <!-- <user-menu/> -->
      <main-menu/>

    </div>
  </div>

</template>

<script>
import MainMenu from './mainMenu'
 import { mapGetters, mapMutations } from 'vuex'
export default {
	name: 'mobile-navbar',
	components: { MainMenu },
	computed: {
		...mapGetters('User', ['user']),

		displayAppName () {
			if (this.user.saasApp) {
				return this.user.saasApp.displayCompanyName
			}
		},
		displayAppImage () {
			if (this.user.saasApp) {
				return `${this.user.saasApp.companyLogo}`
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/components/app/user/partials/navbar/mobile/index.vue